import { createAsyncThunk } from '@reduxjs/toolkit';
import { getTasksRequest } from './operatorTasksApi';
import { TASKS_LIMIT, taskTypesFor } from './operatorTasksUtils';
import { readOperatorError } from '../operator/operatorErrors';
import { selectCurrentOperatorWarehouse, selectCurrentOperatorWarehouseId } from '../operator/operatorUtils';

/**
 * The tray of the current warehouse. Its answer carries, in its meta, when
 * it arrived by the phone's clock (`receivedAt`), so the slice can tell how
 * far that clock is from the server's, and the warehouse it is of.
 */
export const fetchTasks = createAsyncThunk(
  'operatorTasks/fetch',
  async (_, { getState, fulfillWithValue, rejectWithValue }) => {
    const warehouseId = selectCurrentOperatorWarehouseId(getState());
    const types = taskTypesFor(selectCurrentOperatorWarehouse(getState()));
    try {
      const { data } = await getTasksRequest(warehouseId, { types, limit: TASKS_LIMIT });
      return fulfillWithValue(data, { receivedAt: Date.now(), warehouseId });
    } catch (error) {
      return rejectWithValue(readOperatorError(error, 'No pudimos cargar tus tareas.'));
    }
  },
  { condition: (_, { getState }) => selectCurrentOperatorWarehouseId(getState()) != null }
);
